import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

/** Cafe / bakery hero — Brutalist Grind & Earth Clay themes. */
export const heroCafeSpotlightDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.heroCafe,
  componentType: LAYOUT_COMPONENT_TYPE.heroEditorialSplit,
  registryBlockKey: REGISTRY_BLOCK.presentation.heroCoffeeSpotlight,
  displayOrder: 1,
  content: {
    eyebrow: loc3('Single Origin · Daily Roast', 'Single origin · daily roast', 'Single origin · rang xay mỗi ngày'),
    heading: loc3(
      'Spezialitätenkaffee und frisches Gebäck',
      'Specialty coffee and fresh pastry',
      'Cà phê specialty và bánh nướng tươi',
    ),
    subheading: loc3(
      'Vom Espresso bis zum Filter — alles frisch geröstet.',
      'From espresso to pour-over — everything roasted in-house.',
      'Từ espresso đến phin — rang tại chỗ mỗi sáng.',
    ),
    ctaPrimary: loc3('Speisekarte', 'View menu', 'Xem thực đơn'),
    ctaSecondary: loc3('Öffnungszeiten', 'Opening hours', 'Giờ mở cửa'),
  },
  media: {
    heroImage:
      'https://images.unsplash.com/photo-1495474472283-4daf5be1cd43?w=1200&h=900&fit=crop',
  },
};

/** Bar / lounge hero — Neon Noir & Velvet Vintage themes. */
export const heroBarFullBleedDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.heroBar,
  componentType: LAYOUT_COMPONENT_TYPE.heroEditorialSplit,
  registryBlockKey: REGISTRY_BLOCK.presentation.heroFullBleedImage,
  displayOrder: 1,
  content: {
    eyebrow: loc3('Craft Cocktails · Late Night', 'Craft cocktails · late night', 'Cocktail thủ công · đêm muộn'),
    heading: loc3(
      'Signature Drinks unter Neonlicht',
      'Signature drinks under neon light',
      'Đồ uống signature dưới ánh neon',
    ),
    subheading: loc3(
      'Hausgemachte Infusionen, Jazz am Freitag, VIP-Tische auf Anfrage.',
      'House infusions, Friday jazz, VIP tables on request.',
      'Pha chế in-house, jazz thứ Sáu, bàn VIP theo yêu cầu.',
    ),
    ctaPrimary: loc3('Getränkekarte', 'Drinks menu', 'Thực đơn đồ uống'),
    ctaSecondary: loc3('Event buchen', 'Book an event', 'Đặt sự kiện'),
  },
  media: {
    heroImage:
      'https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=1200&h=900&fit=crop',
  },
};

/** Food truck / pop-up hero — Bold Street & Clean Nomad themes. */
export const heroFoodTruckStandardDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.heroFoodTruck,
  componentType: LAYOUT_COMPONENT_TYPE.heroEditorialSplit,
  registryBlockKey: REGISTRY_BLOCK.presentation.heroStandard,
  displayOrder: 1,
  content: {
    eyebrow: loc3('Heute in der Stadt · Route', 'On the road today · route', 'Hôm nay trên đường · lộ trình'),
    heading: loc3(
      'Street Food, frisch vom Grill',
      'Street food, fresh off the grill',
      'Street food, nướng tươi tại chỗ',
    ),
    subheading: loc3(
      'Standort heute, Wochenroute und Catering — alles auf einen Blick.',
      'Today\'s stop, weekly route, and catering — all in one place.',
      'Điểm dừng hôm nay, lộ trình tuần và catering — tất cả ở một nơi.',
    ),
    ctaPrimary: loc3('Standort heute', 'Find us today', 'Vị trí hôm nay'),
    ctaSecondary: loc3('Catering anfragen', 'Catering inquiry', 'Hỏi catering'),
  },
  media: {
    heroImage:
      'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=1200&h=900&fit=crop',
  },
};
